import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};
const app = initializeApp(firebaseConfig);

import { initializeAuth, indexedDBLocalPersistence, browserLocalPersistence } from "firebase/auth";
import { Capacitor } from '@capacitor/core';

export const auth = initializeAuth(app, {
  persistence: Capacitor.isNativePlatform() ? indexedDBLocalPersistence : browserLocalPersistence
});
import { initializeFirestore } from "firebase/firestore";
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
});
export const googleProvider = new GoogleAuthProvider();
export const storage = getStorage(app);
import { getFunctions } from "firebase/functions";
export const functions = getFunctions(app);
export default app;